import { render, staticRenderFns } from "./CeBian.vue?vue&type=template&id=32c2e3b1&scoped=true&"
import script from "./CeBian.vue?vue&type=script&lang=js&"
export * from "./CeBian.vue?vue&type=script&lang=js&"
import style0 from "./CeBian.vue?vue&type=style&index=0&id=32c2e3b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2e3b1",
  null
  
)

export default component.exports